import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

import EventActions from '../../actions/EventActionCreator';
import EventStore from '../../stores/EventStore';

class EventCreateOptionsDialog extends Component {

    constructor() {
        super(...arguments);
        this.state = {templateId: null, templates: []};
    }

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onEventChange = this.onEventChange.bind(this);
        this.eventListener = EventStore.addListener(this.onEventChange);
        EventActions.getTemplates();
    }

    componentWillUnmount() {
        this.eventListener.remove();
    }

    render() {

        return (
            <Dialog
                title={this.props.title}
                modal={false}
                open={this.props.open}
                actions={[
                    <FlatButton key="cancel" label="Cancel" onTouchTap={this.onCancel} />,
                    <FlatButton key="submit" label="Submit" onTouchTap={this.onSave} disabled={!this.state.templateId}/>
                ]}
            >
                <SelectField
                    name="template"
                    value={this.state.templateId}
                    hintText="Template"
                    floatingLabelText="Template"
                    onChange={(e, i, value) => this.setState({templateId: value})}
                    style={{width: '100%'}}
                >
                    {this.state.templates.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name} />)}
                </SelectField>
            </Dialog>
        )
    }

    onSave() {
        browserHistory.push(`/dashboard/event/template/${this.state.templateId}`);
    }

    onEventChange() {
        const templates = EventStore.getByType('template');
        if (templates !== undefined) {
            this.setState({templates});
        }
    }

    onCancel() {
        this.setState({templateId: null});
        this.props.onCancel();
    }
}

EventCreateOptionsDialog.propTypes = {
    title: PropTypes.string.isRequired,
    open: PropTypes.bool,
    onCancel: PropTypes.func
};

export default EventCreateOptionsDialog;
